export function getJWT() {
  try {
    const auth = typeof window !== 'undefined' ? localStorage.getItem('auth') : null;
    if (auth) {
      const { token } = JSON.parse(auth);
      return token;
    }
  } catch (e) {
    console.error('Error reading JWT from storage:', e);
  }
  return null;
}
